import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { DataGrid, type GridColDef, type GridValueGetterParams } from '@mui/x-data-grid';
import { usePagination } from '@/global/hooks/usePagination';
import { apiSearchTransactions } from '@/modules/transactions/services/transactions.services';
import { formatDateTime, getName } from '@/global/helpers/text';
import { type SchoolTransactionDto } from '@/global/api/gen/ts/SchoolTransactionDto';

interface Props {
    id: number,
}

const cashbackTypes = {
    aitest: 'AITest',
    certificate: 'Сертификат'
};

export function TransactionTable({id}: Props) {

    const {api, grid} = usePagination();

    const {data, isLoading} = apiSearchTransactions(id, {...api});

    const renderType = ({row}: GridValueGetterParams<SchoolTransactionDto>) => {
        switch (row.type) {
            case 'manual':
                return row.comment || 'Ручная транзакция';
            case 'cashback':
                return `Кэшбэк ${row.cashback_sum ?? 0}% за ` + `${cashbackTypes[row.cashback_type] ?? 'неизвестная покупка'} ` + `за ${row.original_transaction?.price ?? 0} ${row.original_transaction?.currency ?? 'KZT'} ` + `купил пользователь ${row.original_transaction?.student ? getName(row.original_transaction?.student).fullName : 'неизвестный'} с ИИН: ${row.original_transaction?.iin ?? ''}`;
        }
    };

    const columns: GridColDef<SchoolTransactionDto>[] = useMemo(() => [
        {field: 'id', headerName: 'ID', maxWidth: 100, width: 100, sortable: false},
        {
            field: 'sum',
            headerName: 'Сумма',
            minWidth: 200,
            valueGetter: ({row}) => `${(row.amount) * (row.price)} ${row.currency}`
        },
        {
            field: 'title',
            headerName: 'Тип',
            flex: 1,
            valueGetter: renderType
        },
        {
            field: 'created_at',
            headerName: 'Дата создания',
            sortable: false,
            minWidth: 200,
            valueFormatter: ({value}) => formatDateTime(value)
        }
    ], []);

    return (
        <Box sx={{mt: 2, display: 'flex', flexDirection: 'column', gap: 2}}>
            <DataGrid
                {...grid}
                rows={data?.items ?? []}
                columns={columns}
                loading={isLoading}
                rowCount={data?.total ?? 0}
                disableRowSelectionOnClick
                disableColumnMenu={true}
                disableColumnFilter={true}
            />
        </Box>
    );
}
